import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2354ddf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proposal-select-client" }
const _hoisted_2 = { class: "proposal-select-client__header" }
const _hoisted_3 = { class: "proposal-select-client__header__title" }
const _hoisted_4 = { class: "proposal-select-client__content -mx-4" }
const _hoisted_5 = { class: "w-4/5 px-4" }
const _hoisted_6 = { class: "proposal-select-client__list" }
const _hoisted_7 = { class: "proposal-select-client__list__header" }
const _hoisted_8 = { class: "proposal-select-client__list__menu" }
const _hoisted_9 = { class: "proposal-select-client__list__menu__search w-7/12" }
const _hoisted_10 = { class: "proposal-select-client__list__content relative" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "proposal-select-client__list__items"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "w-4/12 font-medium" }
const _hoisted_15 = { class: "w-5/12" }
const _hoisted_16 = { class: "w-2/12" }
const _hoisted_17 = { class: "w-1/12 flex justify-end" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "proposal-select-client__list__buttons" }
const _hoisted_20 = { class: "w-1/5 px-4" }
const _hoisted_21 = { class: "proposal-select-client__sidebar" }
const _hoisted_22 = { class: "proposal-select-client__sidebar__label" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input = _resolveComponent("search-input")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('proposal.create.select_client.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('proposal.create.select_client.list.header')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_search_input, {
                placeholder: "proposal.create.select_client.list.menu.search",
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                "debounce-time": 0
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_content_loader, {
                  key: 0,
                  label: "general.loading"
                }))
              : _createCommentVNode("", true),
            (!_ctx.elements || !_ctx.elements.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " There are no customers "))
              : _createCommentVNode("", true),
            (_ctx.elements && _ctx.elements.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (customer) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: customer.id,
                      class: _normalizeClass(["proposal-select-client__list__items__item", {'proposal-select-client__list__items__item--active' : customer.id === _ctx.selectedCustomer}]),
                      onClick: ($event: any) => (_ctx.handleCustomerClick(customer))
                    }, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(customer.companyName), 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('proposal.create.select_client.list.content.client_number', {number: customer.id})), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(customer.country?.name), 1),
                      _createElementVNode("span", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: customer.id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCustomer) = $event)),
                          id: "customers-selection"
                        }, null, 8, _hoisted_18), [
                          [_vModelRadio, _ctx.selectedCustomer]
                        ])
                      ])
                    ], 10, _hoisted_13))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_outline_button, {
              disabled: !_ctx.selectedCustomer,
              onClick: _ctx.handleSelectClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('general.select')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_router_link, { to: {name: 'proposal.list'} }, {
              default: _withCtx(() => [
                _createVNode(_component_outline_button, { type: "outline" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('general.cancel')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('proposal.create.select_client.sidebar.label')), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, { to: {name: 'customers.create'} }, {
              default: _withCtx(() => [
                _createVNode(_component_outline_button, null, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createTextVNode("  " + _toDisplayString(_ctx.$t('proposal.create.select_client.sidebar.button')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}